import React from 'react'
import Svg from '../../../../../component/common/Svg'

export default function PreviewFooter() {
    return (
        <div className="preview-footer">
            <div className="next-prev-wrap d-flex justify-content-end">
                <button className="action-btn disabled">
                    <Svg name="prev-question" />
                </button>
                <button className="action-btn">
                    <Svg name="next-question" />
                </button>
            </div>
            <div className="footer-text text-center">
                <p>Copyright 2022. All Rights Reserved.</p>
            </div>
        </div>
    )
}
